import { useUnreadNotificationCount } from './use-unread-count';

/**
 * Unread notification count — exposed standalone so the canonical
 * sidebar nav can render a trailing badge on the `/notifications`
 * row without mounting the full `<NotificationBell>` dropdown.
 *
 * Per `sustevo-handbook/brand/APP_SHELL.md` § 9 the bell does NOT
 * live in chrome; notifications surface as a trailing badge on the
 * relevant nav row (§ 6.2). This hook is the data dependency for
 * that badge.
 *
 * **W132-F5** — was previously a client-side count of the first-N
 * polled rows, which drifted out of sync with `/notifications`
 * (sidebar shows 1, page shows 0). Now wraps the dedicated
 * `useUnreadNotificationCount` hook so the bell + sidebar badge +
 * page all read the same Core-authoritative `total`.
 */
export function useNotificationsUnread(): number {
  const q = useUnreadNotificationCount();
  return q.data?.total ?? 0;
}
